var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injector, OnInit } from '@angular/core';
import { DashboardConsignmentService } from '@app/shared/common/dashboard-service/dashboard-consignment.service';
import { AllCarriesSummaryTable } from '../../models/all-carries-summary-table';
import { WidgetComponentBase } from '../widget-component-base';
import { ConsignmentStatusDashboardServiceProxy } from '@shared/service-proxies/service-proxies';
var WidgetAllCarriesSummaryComponent = /** @class */ (function (_super) {
    __extends(WidgetAllCarriesSummaryComponent, _super);
    function WidgetAllCarriesSummaryComponent(injector, dataService, dashboardConsignmentService) {
        var _this = _super.call(this, injector) || this;
        _this.dataService = dataService;
        _this.dashboardConsignmentService = dashboardConsignmentService;
        _this.allCarriesSummaryTable = new AllCarriesSummaryTable(_this.dataService);
        return _this;
    }
    WidgetAllCarriesSummaryComponent.prototype.ngOnInit = function () {
        this.allCarriesSummaryTable.reload();
    };
    WidgetAllCarriesSummaryComponent.prototype.fieldClick = function (filter) {
        this.dashboardConsignmentService.navigate(filter);
    };
    return WidgetAllCarriesSummaryComponent;
}(WidgetComponentBase));
export { WidgetAllCarriesSummaryComponent };
